// extracted by mini-css-extract-plugin
export default {"gallery":"SavedGallery_gallery__R-LkR","gallery__item":"SavedGallery_gallery__item__CVorh"};